import { INSPECTION_ITEM_TYPE } from '@/constants';
import Form from '@/components/InspectionReport/Items/Form';
import HeaderPage from '@/components/InspectionReport/Items/HeaderPage'; // eslint-disable-line import/no-cycle
import Page from '@/components/InspectionReport/Items/Page.vue';
import Section from '@/components/InspectionReport/Items/Section.vue';
import ConditionalSection from '@/components/InspectionReport/Items/ConditionalSection';
import Action from '@/components/InspectionReport/Items/Action';
import Question from '@/components/InspectionReport/Items/Question';
import UnknownItem from '@/components/InspectionReport/Items/UnknownItem.vue';

export default {
    name: 'item',
    functional: true,
    render(h, { props, parent }) {
        if (props.item.type === INSPECTION_ITEM_TYPE.ACTION) {
            if (!props.resource.template.display_issues) return null;

            const item = props.resource.issues.find(
                (issue) => issue.payload.item_uuid === props.item.uuid,
            );

            if (!item) return null;

            return h('div', { class: 'pb-3 flex flex-col' }, [
                h('span', { class: 'text-70 mb-1' }, parent.$t('Issue')),
                h(Action, { props: { item, displayQuery: false } }),
            ]);
        }

        const item = {
            [INSPECTION_ITEM_TYPE.FORM]: Form,
            [INSPECTION_ITEM_TYPE.PAGE]:
                props.item.params && props.item.params.header
                    ? HeaderPage
                    : Page,
            [INSPECTION_ITEM_TYPE.SECTION]: Section,
            [INSPECTION_ITEM_TYPE.CONDITIONAL]: ConditionalSection,
            [INSPECTION_ITEM_TYPE.QUESTION]: Question,
        }[props.item.type] || UnknownItem;

        return h(item, {
            class: props.item.type,
            props,
        });
    },
};
